/**
 * Homepage Hero Slider
 * Image Gallery Slider
 *
 */
jQuery(document).ready(function($) {
	// Hero Slider
	$('.home-hero, .venue-hero, .event-gallery').slick({
		dots: true,
		infinite: true,
		speed: 500,
		fade: true,
		cssEase: 'linear'
	});
	$(window).on('resize', function(){
		$('.home-hero, .venue-hero, .event-gallery').slick('resize');
	});
});
